/** Baixa um Blob no navegador (modelo e exportação do MICE). */
export function downloadBlob(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = filename;
  anchor.click();
  // Adia: revogar na hora pode cancelar o download em alguns navegadores.
  setTimeout(() => {
    URL.revokeObjectURL(url);
  }, 0);
}
